import { css } from 'styled-components';

export const Popovers = css`
  body {
    .popover {
      box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
      font-family: ${({ theme }) => theme.font.main};
      font-size: 1.4rem;
      max-width: 62vw;
      width: auto;

      .popover-header,
      .popover-body {
        font-size: 1.4rem;

        fieldset {
          border: 0;
          margin: 0 0 1rem 0;
          padding: 0;
        }

        .actions {
          display: flex;
          justify-content: flex-end;
          margin: 1.5rem 0 0 0;

          button {
            margin-left: .5em;
            padding: 5px 8px;
          }
        }
      }

      .popover-body {
        max-width: 100%;
        width: 100%;
      }
    }
  }
`;
